// extracted by mini-css-extract-plugin
export var hideBackdrop = "ModalOverlay-module--hideBackdrop--3a66e";
export var overlay = "ModalOverlay-module--overlay--e4734";